import template from './popup-menu.html';
import './popup-menu.global.css';

class PopupMenuController {
  constructor(updPopupToggleService) {
    'ngInject';
    Object.assign(this, { updPopupToggleService });
  }

  $onInit() {
    this._buttonId = Math.random();
    this._menuId = Math.random();
  }

  get buttonId() {
    return this._buttonId;
  }

  set buttonId(value) {
    this._buttonId = value;
  }

  get menuId() {
    return this._menuId;
  }

  set menuId(value) {
    this._menuId = value;
  }

  get open() {
    return this.updPopupToggleService.isOpen(this.menuId);
  }

  toggle(value) {
    this.updPopupToggleService.toggle(this.menuId, value);
  }
}

export const PopupMenuComponent = {
  controller: PopupMenuController,
  bindings: {
    items: '<',
    menuId: '@',
    buttonId: '@',
    change: '&',
  },
  transclude: {
    toggleButton: 'updPopupToggleButtonContent',
    menu: '?updPopupMenuContent',
  },
  template,
};
